export const CollisionLayer = {
  WORLD: 1,
  PLAYER: 2,
  VEHICLE: 4,
  TRANSIT: 8,
  SENSOR: 16,
  NPC: 32,
} as const;

export function interactionGroups(membership: number, filter: number): number {
  return ((membership & 0xffff) << 16) | (filter & 0xffff);
}

export const PLAYER_GROUPS = interactionGroups(
  CollisionLayer.PLAYER,
  CollisionLayer.WORLD | CollisionLayer.VEHICLE | CollisionLayer.TRANSIT | CollisionLayer.NPC,
);
